import { type DefaultOptionType } from 'antd/es/select';
import { type IProfile } from 'src/types/user/types';

export const dumpListUsers = (data: IProfile[]): DefaultOptionType[] => {
  return data.map(item => ({
    value: item.principalName,
    label: item.pib
  }))
};
